var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-box"},[_c('img',{attrs:{"src":_vm.emptyImg,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.text))]),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }